import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import useCustomerContext from "Contexts/customer-context";
import { useGlobalNotificationBanner } from "Shared/util/custom-hooks";
import {
    ErpIntegrationActivationTypeResource,
    ErpIntegrationProviderIdResource,
} from "Shared/util/types";
import TextLink from "Shared/components/text-link";

export const useGlobalErpIntegrationOAuthReactivationBanner = () => {
    const history = useHistory();
    const { customerData, loadingCustomerData } = useCustomerContext();
    const {
        NotificationBannerType,
        addGlobalNotificationBanner,
        removeGlobalNotificationBanner,
    } = useGlobalNotificationBanner();

    const { activeErpIntegration } = customerData || {};

    useEffect(() => {
        if (loadingCustomerData) return;

        const BANNER_ID = "ERP_INTEGRATION_OAUTH_INACTIVE_CONNECTION";

        if (
            activeErpIntegration?.activationType ===
                ErpIntegrationActivationTypeResource.OAuth &&
            activeErpIntegration?.oAuth.reactivationRequired
        ) {
            const getActivationPagePath = () => {
                switch (activeErpIntegration.providerId) {
                    case ErpIntegrationProviderIdResource.Fortnox:
                        return "/sales-methods/fortnox-setup";

                    default:
                        return "";
                }
            };

            addGlobalNotificationBanner(
                (tnb) => (
                    <>
                        {tnb.format(tnb.erp_integration_inactive_connection, {
                            providerName: activeErpIntegration.providerName,
                        })}
                        {` `}
                        <TextLink
                            text={tnb.erp_integration_inactive_connection_link}
                            link={() => history.push(getActivationPagePath())}
                        />
                    </>
                ),
                NotificationBannerType.Attention,
                true,
                BANNER_ID,
            );
        } else {
            removeGlobalNotificationBanner(BANNER_ID);
        }
    }, [loadingCustomerData, activeErpIntegration]);
};
